import * as React from 'react'

import Svg, {
  ClipPath,
  Defs,
  G,
  Path,
  RadialGradient,
  Stop,
} from 'react-native-svg'

const Share = ({ size = 24, ...props }: { size: number }) => (
  <Svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <G clipPath="url(#a)">
      <Path
        fill="#F2F7FF"
        d="M21.5 0H2.3A2.4 2.4 0 0 0-.1 2.4v19.2A2.4 2.4 0 0 0 2.3 24h19.2a2.4 2.4 0 0 0 2.4-2.4V2.4A2.4 2.4 0 0 0 21.5 0Z"
      />
      <Path
        fill="url(#b)"
        d="M15.9 17.6a.7.7 0 0 1-.375-.11l-7.7-4.9a.7.7 0 0 1 0-1.18l7.7-4.9a.7.7 0 1 1 .752 1.18L9.504 12l6.771 4.31a.7.7 0 0 1-.375 1.29Z"
      />
      <Path
        fill="url(#c)"
        d="M8.2 15.325a3.325 3.325 0 1 0 0-6.65 3.325 3.325 0 0 0 0 6.65Z"
      />
      <Path
        fill="url(#d)"
        d="M15.9 9.725a2.625 2.625 0 1 0 0-5.25 2.625 2.625 0 0 0 0 5.25Z"
      />
      <Path
        fill="url(#e)"
        d="M15.9 19.525a2.625 2.625 0 1 0 0-5.25 2.625 2.625 0 0 0 0 5.25Z"
      />
    </G>
    <Defs>
      <RadialGradient
        id="b"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="matrix(-9.4398 13.61552 -11.46576 -7.94934 16.601 3.95)"
        gradientUnits="userSpaceOnUse"
      >
        <Stop stopColor="#FFE0B9" />
        <Stop offset={1} stopColor="#CD9A58" />
      </RadialGradient>
      <RadialGradient
        id="c"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="rotate(132.995 3.53 6.95) scale(8.2341 7.63854)"
        gradientUnits="userSpaceOnUse"
      >
        <Stop stopColor="#9DC2FF" />
        <Stop offset={1} stopColor="#3D7FEB" />
      </RadialGradient>
      <RadialGradient
        id="d"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="rotate(132.995 8.016 6.35) scale(6.50064 6.03042)"
        gradientUnits="userSpaceOnUse"
      >
        <Stop stopColor="#9DC2FF" />
        <Stop offset={1} stopColor="#3D7FEB" />
      </RadialGradient>
      <RadialGradient
        id="e"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="rotate(132.995 5.885 11.25) scale(6.50064 6.03042)"
        gradientUnits="userSpaceOnUse"
      >
        <Stop stopColor="#9DC2FF" />
        <Stop offset={1} stopColor="#3D7FEB" />
      </RadialGradient>
      <ClipPath id="a">
        <Path fill="#fff" d="M0 0h24v24H0z" />
      </ClipPath>
    </Defs>
  </Svg>
)
export default Share
